import { render, staticRenderFns } from "./Coverages.vue?vue&type=template&id=f5e2e11c"
import script from "./Coverages.vue?vue&type=script&lang=js"
export * from "./Coverages.vue?vue&type=script&lang=js"
import style0 from "./Coverages.vue?vue&type=style&index=0&id=f5e2e11c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports